export default __webpack_public_path__ + "static/media/checkmark.b6e1efe2.svg";